import { render, staticRenderFns } from "./Crisis_major_consult.vue?vue&type=template&id=49219971"
import script from "./Crisis_major_consult.vue?vue&type=script&lang=js"
export * from "./Crisis_major_consult.vue?vue&type=script&lang=js"
import style0 from "./Crisis_major_consult.vue?vue&type=style&index=0&id=49219971&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports